module.exports = __webpack_public_path__ + "static/media/search.cea26080.svg";